import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';

export default function Content() {

    const { t } = useTranslation();

    return (
        <div className='flex flex-col gap-10 max-w-[1280px] mx-auto px-6 py-24 relative w-full'>
            <div className='flex flex-col gap-4'>
                <h5 className='font-bold'>Our Vision</h5>
                <p>To be the leading one-stop provider of certification, validation, and verification services across Indonesia</p>
            </div>
            <div className='flex flex-col gap-4'>
                <h5 className='font-bold'>What We Do</h5>
                <p>We offer impartial and trusted services that empower decision-makers to ensure their products, systems, and projects meet critical environmental and quality benchmarks</p>
                <p>Our assessments are backed by sound practices, a commitment to excellence, and a diverse team of experts who deliver both speed and precision</p>
            </div>
            <div className='flex flex-col gap-4'>
                <h5 className='font-bold'>Our Purpose</h5>
                <p>Our objective is to support organizations, project developers, managers, and communities on their journey toward environmental responsibility</p>
                <p>From accurately measuring carbon footprints to facilitating meaningful climate transitions, we contribute to the global effort to combat climate change</p>
                <p>More than a service provider, we are a partner—offering guidance grounded in diligence, expertise, and an unwavering commitment to a sustainable future</p>
            </div>
            <div className='flex flex-col gap-4'>
                <h5 className='font-bold'>Why Choose NatureTrust</h5>
                <ul className='list-disc pl-5'>
                    <li><b>Expertise Across Industries:</b> Our team of specialists is highly experienced in carbon accounting, forestry, supply chain auditing, and sustainability standards</li>
                    <li><b>Customized Solutions:</b> We recognize that no two clients or projects are alike
                    <p> That's why we offer a wide range of certification and verification schemes tailored to individual needs and objectives</p>
                    </li>
                    <li><b>Compliance and Risk Mitigation:</b> We help clients navigate complex regulations and standards, reducing the risk of non-compliance and bolstering their reputation</li>
                    <li><b>Sustainable Growth:</b> Our services assist organizations in developing responsible practices that lower their carbon footprint and elevate their corporate image—providing a strategic advantage in a competitive market</li>
                </ul>
            </div>
                <div className='font-bold gap-4 flex flex-col'>
                    <p >At NatureTrust, we don't just assess; we empower</p>
                    <p >We partner with clients to shape a more sustainable, credible, and climate-resilient future</p>
                </div>
        </div>
    );
}
